import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { Modal, Header, Button, Icon } from "semantic-ui-react";

import { hydrateCopyObjectWithEntity } from "../../state/reducers/locale/copyUtils.js";

class ConfirmationModal extends PureComponent {
  static propTypes = {
    onConfirm: PropTypes.func,
    onClose: PropTypes.func.isRequired,
    entity: PropTypes.object,
    open: PropTypes.bool.isRequired,
    copy: PropTypes.object.isRequired
  };

  closeHandler = (evt, data) => {
    const { onClose, onConfirm } = this.props;

    const confirmed = data["data-confirmed"] === "true";

    if (confirmed && onConfirm) {
      onConfirm(confirmed);
    } else {
      onClose(confirmed);
    }
  };

  render() {
    const { children, entity, copy, open } = this.props;

    const hydratedCopy = hydrateCopyObjectWithEntity(copy, entity);

    if (!open) return null;

    return (
      <Modal closeIcon open={open} onClose={this.closeHandler}>
        <Header icon="exclamation circle" content={hydratedCopy.title} />
        <Modal.Content>
          <p>{hydratedCopy.message}</p>
          {children}
        </Modal.Content>
        <Modal.Actions>
          <Button
            color="red"
            type="button"
            data-confirmed="false"
            onClick={this.closeHandler}
          >
            <Icon name="remove" /> {hydratedCopy.no}
          </Button>
          <Button
            color="green"
            type="submit"
            autoFocus={true}
            data-confirmed="true"
            onClick={this.closeHandler}
          >
            <Icon name="checkmark" /> {hydratedCopy.yes}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default ConfirmationModal;
